module.exports = __webpack_public_path__ + "fonts/NotoSans-Bold.d4601b74.woff";